import axios from 'axios';
import WebApiService from '../services/WebApiService';

export default class AdvertisementService extends WebApiService {

    constructor() {
        super();
    }

    getContent(successCallback, errorCallback) {
        if (zzDataCache.account != null) {
            let userId = zzDataCache.account.userId;
            this.getAnon('/api/Content/GetContent/' + userId, successCallback, errorCallback);
        }
    }

    clickContent(contentId, successCallback, errorCallback) {
        if (zzDataCache.account != null) {
            this.getAnon('/api/Content/ClickContent/' + zzDataCache.account.userId + '/' + contentId, successCallback, errorCallback);
        }
    }
}